/**
 * Responsive utils for material-ui
 * @flow
 */

type Width = "xs" | "sm" | "md" | "lg" | "xl";

const widths = {
  xs: 0,
  sm: 1,
  md: 2,
  lg: 3,
  xl: 4,
};

export function up(than: Width, currentWidth: Width) {
  return widths[than] <= widths[currentWidth];
}

export function down(than: Width, currentWidth: Width) {
  return widths[than] >= widths[currentWidth];
}
